import React from "react";
import Children from "react-children-utilities";

export function findRoot(children, type) {
    return Children.deepFind(children, (child) => child.type === type) || null;
}
